<template>
  <section
    id="careerup"
    class="te-careerup py-[3.25rem] md:py-20"
  >
    <h2 class="co-heading-2">
      リスキリングを通じた<br class="md:hidden">キャリアアップ支援事業<br>認定講座
    </h2>

    <div class="co-container-md mb-8 bg-co-gray-50 px-6 md:p-10">
      <div class="md:flex md:px-5">
        <div class="basis-3/12 py-10 text-center md:mr-10 md:p-0 md:text-left">
          <img
            class="mx-auto"
            src="~/assets/images/Te/TeCommon/CareerUp/careerup.webp"
            alt="経済産業省 リスキリングを通じたキャリアアップ支援事業"
            width="199"
            height="90"
            loading="lazy"
          >
        </div>
        <div class="mb-6 basis-9/12 px-0">
          <span class="te-careerup-cashback mb-3 inline-block border-b-2 border-co-danger-500 font-bold md:mb-2">
            最大<b class="te-careerup-cashback-number font-bold text-co-danger-500">70</b>%
            <!-- キャッシュバック金額表記 -->
            <template v-if="cashbackAmount">
              、<b class="te-careerup-cashback-number font-bold text-co-danger-500">
                <slot name="cashback">
                  <!-- コース10週間の表記 -->
                  <template v-if="course10weeks">
                    {{ $addComma(coursePrices.social_10weeks.reskilling_refund_price) }}
                  </template>
                  <!-- コース12週間の表記 -->
                  <template v-else-if="course12weeks">
                    {{ $addComma(coursePrices.social_12weeks.reskilling_refund_price) }}
                  </template>
                  <!-- コース16週間の表記 -->
                  <template v-else-if="course16weeks">
                    {{ $addComma(coursePrices.social_16weeks.reskilling_refund_price) }}
                  </template>
                  <!-- セット16週間の表記 -->
                  <template v-else-if="set16weeks">
                    {{ $addComma(setPrices.standard_week16.reskilling_refund_price) }}
                  </template>
                  <!-- セット22週間の表記 -->
                  <template v-else-if="set22weeks">
                    {{ $addComma(setPrices.standard_week22.reskilling_refund_price) }}
                  </template>
                  <!-- セット24週間の表記 -->
                  <template v-else-if="set24weeks">
                    {{ $addComma(setPrices.standard_week24.reskilling_refund_price) }}
                  </template>
                  <!-- 上記以外 -->
                  <template v-else>-</template>
                </slot>
              </b>円<span class="co-display-12">※</span>
            </template>
            キャッシュバック！
          </span>
          <span
            v-if="cashbackAmount"
            class="co-display-14 mb-3 block leading-tight text-co-gray-600"
          >
            ※キャッシュバックは受講料の税抜価格から計算されます。
          </span>
          <p class="co-display-12 mb-0 text-co-gray-600">
            当コースは経済産業省のリスキリングを通じたキャリアアップ支援事業に認定され、条件を満たすことで受講のために支払う受講料の最大
            <span class="co-display-10 font-bold">70%</span>
            が還元されます。
          </p>
        </div>
      </div>
      <div class="pb-10 md:p-5 lg:flex">
        <div class="px-0 md:basis-6/12 md:pr-6">
          <p class="co-display-12 mb-4 font-bold">
            注意事項（必ずお読みください）
          </p>
          <ul class="co-display-13 mb-4 list-disc pl-6 text-co-gray-600 lg:mb-0">
            <li class="mb-3">
              当制度のご利用には
              <a
                href="https://techacademy.jp/benefits/reskilling#condition"
                target="_blank"
              >詳細ページ</a>
              の受講料の補助対象となるリスキリング講座をよくお読みになってください。
            </li>
            <li class="mb-3">
              お申し込み後、受講開始前にキャリアカウンセリングアンケートを回答いただくこと。
            </li>
            <li class="mb-3">
              対象コースを修了すること（詳細は修了条件に記載）。
            </li>
            <li class="mb-3">
              本人名義で申込・受講料振込をしていただくこと。
            </li>
            <li class="mb-3">
              追加補助の20%について、テックアカデミーキャリア以外のサービスで転職された場合は対象外。
            </li>
            <li class="mb-3">
              弊社では当制度のご利用に関する個別のご意見やご要望をお受けすることができません。
            </li>
            <li>当制度の手続き上、お申し込み後の内容変更はできませんのでご注意ください。</li>
          </ul>
        </div>
        <div class="px-0 md:basis-6/12">
          <p class="co-display-12 mb-4 font-bold">
            修了条件（必ずお読みください）
          </p>
          <ul class="co-display-13  mb-0 list-disc pl-6 text-co-gray-600">
            <li class="mb-3">
              お申し込み後、受講開始前にキャリアカウンセリングアンケートを回答いただくこと。
            </li>
            <li class="mb-3">
              カリキュラムの課題をすべて提出し合格している。
            </li>
            <li>受講中にキャリアカウンセリングを規定の回数受ける。</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="text-center">
      <a
        class="bot_open co-btn-counseling mb-4"
        href="/counseling/htmlcss-schedule"
      >
        まずは相談してみる
        <FontAwesomeIcon
          :icon="faAngleRight"
          class="fa-fw ml-2 inline h-3 w-2"
        />
      </a>
      <div>
        リスキリング補助制度の<a
          href="https://techacademy.jp/benefits/reskilling"
          class="co-link-color-500"
        >詳細はこちら</a>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faAngleRight,
    }
  },
  props: {
    course: {
      type: Object,
      default: null,
    },
    pack: {
      type: Object,
      default: null,
    },
    // キャッシュバック金額表記
    cashbackAmount: {
      type: Boolean,
      default: true,
    },
    course10weeks: {
      type: Boolean,
      default: false,
    },
    course12weeks: {
      type: Boolean,
      default: false,
    },
    course16weeks: {
      type: Boolean,
      default: false,
    },
    set16weeks : {
      type: Boolean,
      default: false,
    },
    set22weeks : {
      type: Boolean,
      default: false,
    },
    set24weeks : {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
  computed: {
    coursePrices() {
      return this.course
        ? this.course.attributes.prices
        : {
            social_10weeks: { reskilling_refund_price: '-' },
            social_12weeks: { reskilling_refund_price: '-' },
            social_16weeks: { reskilling_refund_price: '-' },
          }
    },
    setPrices() {
      return this.pack
        ? this.pack.attributes.prices
        : {
            standard_week16: { reskilling_refund_price: '-' },
            standard_week22: { reskilling_refund_price: '-' },
            standard_week24: { reskilling_refund_price: '-' },
          }
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-careerup {
  background-color: #e8f7ff;
}

.te-careerup-cashback {
  font-size: 0.875rem;
  line-height: 1.2;
  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
}

.te-careerup-cashback-number {
  font-size: 1.25rem;
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}

.te-btn-ghost-white {
  display: inline-flex;
  align-items: center;
  padding: .75rem 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  transition: all .5s ease;
  @apply text-co-gray-700 border-co-gray-700 rounded-full border-2;
  &:hover {
    background-color: rgba(0, 0, 0, .3);
  }
}
</style>
